<template>
    <form class="contactUpdate modify modify-contact warn-on-exit" method="post">
        <!-- Basic Information -->
        <fieldset>
            <div class="form-body">
                <div class="form-group">
                    <txt label="title" v-model="model.title"></txt>
                </div>
                <div class="form-group">
                    <input type="checkbox" v-model="model.page_break" /> <label>Page Break</label><br>
                </div>
            </div><!-- .form-body -->
        </fieldset>
        <ckeditor  :toolbar="[['Source', 'Format'], ['Font','FontSize'], ['Bold', 'Italic', 'SpecialChar', 'Scayt'], ['Undo', 'Redo'], ['NumberedList','BulletedList'], ['Link','Unlink'], ['Maximize'], ['Image'], ['Outdent', 'Indent', 'Styles'] ]"
                :extradata="{
            allowedContent: true,
            removePlugins: 'htmldataprocessor',
            filebrowserImageBrowseUrl: '/laravel-filemanager?type=Images',
            // filebrowserBrowseUrl: '/laravel-filemanager?type=Files',
            // filebrowserUploadUrl: '/invoice/upload/?_token=' + token,
            // filebrowserUploadMethod: 'form'
        }"></ckeditor>
        <div class="buttons">
            <button @click.prevent="store" class="btn btn-success btn-sml"><i class="icon icon-save"></i> Save</button>
        </div>
        </form>
</template>

<script>
    import Ckeditor from "../ckeditor/ckeditor";
    export default {
        components: {
            Ckeditor,
        },
        props: {
            name: { default: '' },
        },
        data() {
            return {
                token: window.Laravel.csrfToken,
                model: {
                    public_id: 0,
                    sort_order: 0,
                    title: '',
                    page_break: false,
                    type: 'htmlBlock',
                    content: '',
                },
                address: {}
            }
        },
        created() {
            this.$eventHub.$on('proposalSubmit', this.store);
            this.$eventHub.$on('updateCkeditorHtml', this.updateHtml);
            this.$eventHub.$on('setProposal', this.setProposal);
        },
        methods: {
            setProposal(data) {
                this.model = this.$setData(data, this.model);
                this.$eventHub.$emit('updateCkeditor', this.model.content);
            },
            updateHtml(html){
                this.model.content = html;
            },
            primary() {
                this.axios.post('/api/contact/primary', {
                    id: this.model.public_id,
                    company: window.currentCompany
                });
            },
            store(data) {
                this.$store('/api/proposal/post', this);
            },
            callback() {
                this.$eventHub.$emit('updateHtmlBlock', this.model);
            }
        },
        // It's good to clean up event listeners before a component is destroyed.
        beforeDestroy () {
        }
    }
</script>
